{
  "version": 1,
  "asset_id": "94e97dfc-a33a-4bf7-9bf2-86b7975323ae",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/94e97dfc-a33a-4bf7-9bf2-86b7975323ae/sleeve-to-bypass-first-view-en.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/94e97dfc-a33a-4bf7-9bf2-86b7975323ae/sleeve-to-bypass-first-view-en.png",
  "original_filename": "sleeve-to-bypass-first-view-en.png",
  "size": 1013638,
  "content_type": "image/png",
  "created_at": "2026-10-05T12:33:46Z"
}
